export const carouselItems = [
  {
    title: '韩漫精选：人气恋爱漫推荐',
    desc: '精选韩国人气恋爱漫画，画风精美剧情动人，持续更新中',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20romance%20comic%20cover%2C%20two%20characters%20facing%20each%20other%20in%20soft%20pastel%20colors%2C%20warm%20evening%20light%2C%20clean%20minimal%20background%2C%20artistic%20manga%20panel%20composition%2C%20gentle%20atmospheric%20gradient&width=640&height=400&seq=carousel-01&orientation=landscape',
    tag: '韩漫精选',
  },
  {
    title: '日漫经典：热血冒险全收录',
    desc: '经典日本热血冒险漫画，高燃剧情不间断，陪伴一代人的青春记忆',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20action%20adventure%20illustration%2C%20dynamic%20character%20posing%20with%20energy%20effects%2C%20warm%20sunset%20orange%20and%20gold%20gradient%20background%2C%20clean%20composition%20with%20speed%20lines%2C%20shonen%20style%20artwork&width=640&height=400&seq=carousel-02&orientation=landscape',
    tag: '日漫经典',
  },
  {
    title: '国漫崛起：原创精品一览',
    desc: '国产原创漫画精品力作，题材丰富画风多样，见证国漫新力量',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20with%20traditional%20ink%20painting%20elements%20blended%20with%20modern%20comic%20art%2C%20elegant%20character%20in%20flowing%20robes%2C%20warm%20amber%20and%20coral%20background%20with%20soft%20clouds%2C%20artistic%20composition&width=640&height=400&seq=carousel-03&orientation=landscape',
    tag: '国漫崛起',
  },
  {
    title: '本周热门：连载追更指南',
    desc: '本周最受读者追捧的连载作品，一网打尽快来追上进度',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20multiple%20manga%20book%20covers%20floating%20in%20warm%20ambient%20light%2C%20vibrant%20colors%20with%20coral%20and%20amber%20tones%2C%20clean%20modern%20layout%2C%20editorial%20photography%20style%2C%20soft%20gradient%20background&width=640&height=400&seq=carousel-04&orientation=landscape',
    tag: '本周热门',
  },
  {
    title: '完结佳作：一口气看到底',
    desc: '已完结的经典漫画合集，不用等更新，一次看个痛快',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20completed%20manga%20volumes%20artistically%20arranged%20on%20warm%20wooden%20surface%2C%20soft%20natural%20lighting%20from%20window%2C%20cozy%20reading%20atmosphere%2C%20warm%20beige%20and%20amber%20color%20palette%2C%20clean%20composition&width=640&height=400&seq=carousel-05&orientation=landscape',
    tag: '完结佳作',
  },
  {
    title: '新人必看：入门推荐清单',
    desc: '漫画新读者的入门指南，精选各类型代表作轻松上手',
    image: 'https://readdy.ai/api/search-image?query=Welcoming%20anime%20style%20illustration%20with%20friendly%20characters%20waving%2C%20colorful%20speech%20bubbles%20and%20stars%2C%20warm%20inviting%20atmosphere%2C%20soft%20gradient%20background%20in%20coral%20and%20cream%20tones%2C%20playful%20composition&width=640&height=400&seq=carousel-06&orientation=landscape',
    tag: '新人必看',
  },
];

export const rankingItems = [
  { rank: 1, title: '斗罗大陆', author: '唐家三少', category: '国漫·玄幻', views: '2.8亿', status: '连载中' },
  { rank: 2, title: '女神降临', author: '猫咪', category: '韩漫·恋爱', views: '1.6亿', status: '连载中' },
  { rank: 3, title: '海贼王', author: '尾田荣一郎', category: '日漫·冒险', views: '3.2亿', status: '连载中' },
  { rank: 4, title: '我独自升级', author: 'Chugong', category: '韩漫·战斗', views: '1.2亿', status: '已完结' },
  { rank: 5, title: '一人之下', author: '米二', category: '国漫·奇幻', views: '9800万', status: '连载中' },
  { rank: 6, title: '咒术回战', author: '芥见下下', category: '日漫·战斗', views: '1.5亿', status: '连载中' },
];

export const faqItems = [
  {
    q: '妖精动漫上的漫画都是免费的吗？',
    a: '是的，妖精动漫平台上所有漫画均为免费阅读，无需付费订阅即可畅享韩漫、日漫、国漫全集内容，下拉式翻页设计让阅读体验更加流畅。',
  },
  {
    q: '妖精动漫支持哪些类型的漫画？',
    a: '妖精动漫全面覆盖韩国漫画、日本漫画、国产漫画三大类别，涵盖恋爱、热血、玄幻、奇幻、悬疑、搞笑等多种题材，满足不同读者的阅读需求。',
  },
  {
    q: '如何在妖精动漫上找到想看的漫画？',
    a: '您可以通过首页的搜索功能查找作品，也可以浏览人气排行、热门专题、漫画索引等模块，按类别、热度或更新状态快速定位感兴趣的内容。',
  },
  {
    q: '妖精动漫的更新频率怎么样？',
    a: '妖精动漫保持高频更新节奏，每日有大量新章节上线，热门连载作品保持同步更新，让追更的读者不错过任何精彩剧情。',
  },
  {
    q: '在手机上可以看妖精动漫吗？',
    a: '当然可以！妖精动漫支持手机浏览器直接访问，也有专属APP提供更沉浸的阅读体验，下拉式翻页在移动端同样流畅好用。',
  },
  {
    q: '妖精动漫是否需要注册才能阅读？',
    a: '妖精动漫大部分内容无需注册即可直接阅读。注册账号后可享受收藏漫画、阅读记录同步、评论互动等更多个性化功能。',
  },
];

export const appItem = {
  title: '妖精动漫 APP',
  desc: '随时随地畅享韩漫日漫国漫，下拉式流畅翻页，离线缓存想看就看，推送提醒不错过更新',
  features: ['流畅翻页', '离线缓存', '夜间模式', '更新提醒'],
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20manga%20reading%20app%20interface%20with%20Korean%20webtoon%20style%20art%2C%20clean%20modern%20UI%20design%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20soft%20gradient%20background%2C%20minimal%20product%20photography%20style&width=400&height=700&seq=app-showcase&orientation=portrait',
};

export const mediaItems = [
  {
    title: '韩漫推荐：《女神降临》精彩片段',
    desc: '画风超美的韩国恋爱漫画，每一帧都能当壁纸',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20webtoon%20style%20romance%20scene%20with%20two%20characters%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20amber%20lighting%2C%20clean%20artistic%20composition%2C%20gentle%20atmosphere&width=480&height=320&seq=media-01&orientation=landscape',
  },
  {
    title: '日漫热血：《咒术回战》高燃战斗',
    desc: '年度最燃日本战斗漫画，分镜炸裂燃到不行',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20Japanese%20manga%20action%20scene%20with%20energy%20effects%20and%20speed%20lines%2C%20warm%20orange%20and%20coral%20explosive%20background%2C%20shonen%20style%20art%2C%20powerful%20composition&width=480&height=320&seq=media-02&orientation=landscape',
  },
  {
    title: '国漫精品：《一人之下》名场面',
    desc: '国产漫画巅峰之作，传统文化与现代漫画完美结合',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20blending%20traditional%20Taoist%20elements%20with%20modern%20comic%20art%2C%20mystical%20atmosphere%20with%20warm%20golden%20light%2C%20elegant%20character%20posing&width=480&height=320&seq=media-03&orientation=landscape',
  },
  {
    title: '新番速递：本月必追连载清单',
    desc: '每月新上线的热门连载作品，抢先一步加入书架',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20arrangement%20of%20colorful%20manga%20covers%20and%20panels%20layered%20on%20warm%20beige%20background%2C%20soft%20natural%20light%2C%20clean%20editorial%20composition%2C%20vibrant%20yet%20harmonious%20colors&width=480&height=320&seq=media-04&orientation=landscape',
  },
  {
    title: '读者力荐：小众佳作挖掘计划',
    desc: '被埋没的冷门好漫画，每一部都是意外惊喜',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20open%20manga%20book%20and%20warm%20ambient%20lamp%20light%2C%20soft%20cream%20and%20amber%20tones%2C%20peaceful%20atmosphere%2C%20clean%20minimal%20interior%20photography%20style&width=480&height=320&seq=media-05&orientation=landscape',
  },
];

export const featureItems = [
  {
    icon: 'ri-book-open-line',
    title: '海量漫画资源',
    desc: '覆盖韩漫、日漫、国漫三大类别，从热门连载到经典完结，满足各类漫画读者需求',
  },
  {
    icon: 'ri-smartphone-line',
    title: '下拉流畅翻页',
    desc: '专为移动端优化的下拉式阅读体验，翻页顺滑不卡顿，沉浸式看漫画更过瘾',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日高频更新',
    desc: '热门连载同步更新，新章节第一时间上线，追更不等待精彩不间断',
  },
  {
    icon: 'ri-shield-check-line',
    title: '完全免费阅读',
    desc: '妖精动漫承诺所有漫画内容永久免费，无需付费会员即可畅享全集阅读',
  },
];

export const topicItems = [
  { tag: '韩漫推荐', count: '2.3万讨论' },
  { tag: '日漫新番', count: '1.8万讨论' },
  { tag: '国漫崛起', count: '1.5万讨论' },
  { tag: '恋爱漫画', count: '9800讨论' },
  { tag: '热血冒险', count: '8700讨论' },
  { tag: '玄幻修仙', count: '7600讨论' },
  { tag: '悬疑推理', count: '6500讨论' },
  { tag: '搞笑日常', count: '5900讨论' },
  { tag: '完结推荐', count: '5200讨论' },
  { tag: '画风鉴赏', count: '4800讨论' },
  { tag: '新人入门', count: '4100讨论' },
];

export const indexItems = [
  { title: '韩国漫画专区', desc: '精选韩漫全集', count: '1.2万部', image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20and%20drama%20illustration%20collection%2C%20soft%20pastel%20colors%2C%20warm%20coral%20and%20cream%20gradient%20background%2C%20clean%20elegant%20composition&width=400&height=300&seq=index-01&orientation=landscape' },
  { title: '日本漫画专区', desc: '经典日漫大全', count: '2.5万部', image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20action%20and%20adventure%20illustration%2C%20dynamic%20shonen%20art%2C%20warm%20orange%20and%20amber%20gradient%20background%2C%20clean%20composition&width=400&height=300&seq=index-02&orientation=landscape' },
  { title: '国产漫画专区', desc: '原创国漫精品', count: '9800部', image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20fantasy%20illustration%20with%20traditional%20elements%2C%20warm%20golden%20and%20coral%20lighting%2C%20elegant%20character%20design%2C%20clean%20artistic%20composition&width=400&height=300&seq=index-03&orientation=landscape' },
  { title: '恋爱漫画合集', desc: '甜蜜恋爱故事', count: '6800部', image: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20style%20illustration%20with%20cherry%20blossoms%20and%20soft%20pink%20lighting%2C%20couple%20silhouette%2C%20warm%20gentle%20atmosphere%2C%20clean%20composition&width=400&height=300&seq=index-04&orientation=landscape' },
  { title: '热血冒险合集', desc: '高燃战斗剧情', count: '7500部', image: 'https://readdy.ai/api/search-image?query=Action%20packed%20manga%20style%20illustration%20with%20dynamic%20posing%20and%20energy%20bursts%2C%20warm%20orange%20and%20red%20gradient%2C%20powerful%20composition&width=400&height=300&seq=index-05&orientation=landscape' },
  { title: '完结佳作合集', desc: '一口气看完', count: '5600部', image: 'https://readdy.ai/api/search-image?query=Stack%20of%20completed%20manga%20volumes%20with%20warm%20lighting%2C%20cozy%20reading%20atmosphere%2C%20cream%20and%20amber%20color%20palette%2C%20clean%20editorial%20style&width=400&height=300&seq=index-06&orientation=landscape' },
  { title: '每日更新追踪', desc: '追更不迷路', count: '3200部', image: 'https://readdy.ai/api/search-image?query=Calendar%20style%20illustration%20with%20manga%20chapter%20icons%2C%20warm%20coral%20and%20amber%20accents%2C%20clean%20organized%20layout%2C%20soft%20gradient%20background&width=400&height=300&seq=index-07&orientation=landscape' },
];

export const aboutContent = {
  title: '关于妖精动漫',
  desc: '妖精动漫是国内领先的漫画在线阅读平台，专注为漫画爱好者提供韩漫、日漫、国漫的免费全集阅读服务。平台汇集了超过5万部漫画作品，涵盖韩国漫画、日本漫画、国产漫画三大主流类型，每日更新数百个章节，确保读者追更不等待。\n\n妖精动漫采用先进的下拉式翻页技术，为移动端读者带来流畅沉浸的阅读体验。无论是热门的韩国恋爱漫画，经典的日本热血冒险，还是崛起中的国产原创精品，在妖精动漫都能免费畅读。\n\n我们致力于打造最全面的漫画阅读社区，让每一位漫画读者都能在这里找到自己喜欢的好作品，妖精动漫——好看漫画追更不停。',
  image: 'https://readdy.ai/api/search-image?query=Warm%20inviting%20illustration%20of%20diverse%20manga%20books%20and%20reading%20devices%20arranged%20artistically%2C%20soft%20natural%20light%2C%20cream%20and%20coral%20color%20palette%2C%20cozy%20reading%20community%20atmosphere%2C%20clean%20composition&width=640&height=420&seq=about-illustration&orientation=landscape',
};

export const commentItems = [
  {
    name: '漫画迷小七',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20avatar%20portrait%20with%20warm%20friendly%20expression%2C%20soft%20coral%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-01&orientation=squarish',
    text: '妖精动漫真的太良心了！韩漫日漫国漫都有，而且全是免费的，页面设计也很舒服，下拉翻页特别顺手，已经推荐给身边所有喜欢看漫画的朋友了！',
    date: '2026-07-25',
  },
  {
    name: '深夜追更人',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20male%20avatar%20portrait%20with%20cool%20expression%2C%20warm%20amber%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-02&orientation=squarish',
    text: '追了好几部韩漫都在这里找到全集了，更新速度也很快，每天都有新章节看。国产漫画区也有很多惊喜，发现了好几部质量很高的原创作品！',
    date: '2026-07-24',
  },
  {
    name: '漫画重度用户',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20avatar%20portrait%20with%20glasses%20and%20gentle%20smile%2C%20soft%20cream%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-03&orientation=squarish',
    text: '作为漫画老读者，妖精动漫是我用过最舒服的平台。资源全、加载快、没广告干扰，分类也很清晰。希望平台越做越好，会一直支持下去！',
    date: '2026-07-23',
  },
];

export const updateItems = [
  {
    title: '《女神降临》第234话更新上线',
    desc: '韩漫人气恋爱作品最新章，男女主角感情线迎来重大转折',
    date: '2026-07-28',
    tag: '韩漫更新',
  },
  {
    title: '《一人之下》第612话同步发布',
    desc: '国漫巅峰之作最新回，张楚岚身世之谜即将揭晓',
    date: '2026-07-28',
    tag: '国漫更新',
  },
  {
    title: '《咒术回战》第268话中译版发布',
    desc: '日漫热门连载最新翻译章节上线，战斗场面炸裂',
    date: '2026-07-27',
    tag: '日漫更新',
  },
  {
    title: '「完结佳作」专题页面上线',
    desc: '一口气看完的完结漫画合集，精选500部高分作品',
    date: '2026-07-27',
    tag: '专题活动',
  },
  {
    title: '《我独自升级》番外篇全网首发',
    desc: '韩国现象级战斗漫番外特别篇，讲述主角觉醒前的故事',
    date: '2026-07-26',
    tag: '韩漫更新',
  },
  {
    title: '「新人入门」推荐清单更新',
    desc: '新增30部适合漫画新读者的入门推荐作品，分类更清晰',
    date: '2026-07-25',
    tag: '专题活动',
  },
  {
    title: '《斗罗大陆》第538话重磅更新',
    desc: '国漫玄幻巨制最新章，唐三决战精彩不容错过',
    date: '2026-07-25',
    tag: '国漫更新',
  },
];

export const contactContent = {
  title: '联系我们',
  desc: '有任何建议、合作意向或投稿需求，欢迎通过以下方式联系妖精动漫团队，我们会在第一时间回复您的消息。',
  email: 'contact@yaojingdongman.com',
};

export const cardItems = [
  {
    title: '斗罗大陆',
    desc: '唐三穿越异世，踏上魂师修炼之路',
    category: '国漫·玄幻',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20character%20with%20martial%20arts%20pose%2C%20warm%20golden%20and%20coral%20lighting%2C%20clean%20epic%20composition%2C%20simple%20gradient%20background&width=400&height=500&seq=card-01&orientation=portrait',
    badge: '热门',
  },
  {
    title: '女神降临',
    desc: '化妆改变人生的浪漫爱情故事',
    category: '韩漫·恋爱',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20female%20character%20with%20elegant%20makeup%2C%20soft%20pink%20and%20cream%20background%2C%20beautiful%20illustration%20style%2C%20clean%20composition&width=400&height=500&seq=card-02&orientation=portrait',
    badge: '人气',
  },
  {
    title: '海贼王',
    desc: '路飞与伙伴们追寻大秘宝的冒险',
    category: '日漫·冒险',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20pirate%20adventure%20character%20illustration%2C%20warm%20orange%20and%20amber%20lighting%2C%20dynamic%20posing%2C%20clean%20shonen%20style%2C%20simple%20gradient%20background&width=400&height=500&seq=card-03&orientation=portrait',
    badge: '经典',
  },
  {
    title: '一人之下',
    desc: '异人与道士的奇幻冒险之旅',
    category: '国漫·奇幻',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20supernatural%20character%20with%20Taoist%20elements%2C%20warm%20golden%20light%2C%20mystical%20atmosphere%2C%20clean%20elegant%20composition%2C%20simple%20gradient%20background&width=400&height=500&seq=card-04&orientation=portrait',
    badge: '口碑',
  },
  {
    title: '我独自升级',
    desc: '最弱猎人觉醒成为最强存在',
    category: '韩漫·战斗',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20male%20character%20with%20dark%20cool%20expression%2C%20warm%20coral%20and%20amber%20accent%20lighting%2C%20powerful%20atmosphere%2C%20clean%20composition%2C%20simple%20gradient%20background&width=400&height=500&seq=card-05&orientation=portrait',
    badge: '完结',
  },
];